import smoothscroll from 'smoothscroll-polyfill';



import './infoModal';
import umeMenuInit from './menu';
import scrollDownOnClick from './scrollDown';
import correctActive from "./one-pager-menu-marking";
//import lazyLoadIframes from "./lazyLoadIframes";
import checkTitleSize from "./checkTitleSize";
import showScrollTop from "./scrollTop";
import generalSearch from "./generalSearch";
import resetScrollAfterModalClose from "./resetScrollToPositionAfterModalCloses";
import setScrollPadding from "./setScrollPadding";
import modal from "./modal";
import checkForMenuOverLength from "./checkForMenuOverLength";

import consentmanager from "./consentmanager";
import consentmanagerHandleBackground from "./consentmanagerHandleBackground";
import adjustScrollDownPosition from "./adjustScrollDownPosition";


jQuery(document).ready(() => {
    umeMenuInit();
    scrollDownOnClick();
    smoothscroll.polyfill();
    correctActive();
    //lazyLoadIframes();
    checkTitleSize();
    showScrollTop();
    generalSearch();
    resetScrollAfterModalClose();
    checkForMenuOverLength();
    modal.init();
    adjustScrollDownPosition();
    consentmanager();
    consentmanagerHandleBackground();
});
const loadEvent = new CustomEvent('customUmeLoadEvent', {});
window.onload = (event) => {
    document.dispatchEvent(loadEvent);
    setTimeout(() =>{
        setScrollPadding();
    }, 200)

};
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if(currentWidth === window.innerWidth) return;
    umeMenuInit();
    setScrollPadding();
    checkForMenuOverLength();
    adjustScrollDownPosition();
    currentWidth = window.innerWidth;


});
window.addEventListener('orientationchange', () => {
    umeMenuInit();
    setScrollPadding();
    checkForMenuOverLength();
});


